import { useSelector } from '../../../../Flux/index.js'
import type { State } from '../../../../Flux/Slice/index.js'
import React, { useMemo } from 'react'

export default function ScopeBadge({ fallbackId }: { fallbackId?: string }) {
  const scope = useSelector((s: typeof State) => s.visualization.scope)
  const project = useSelector((s: typeof State) => s.project.currentProject)
  const order = useSelector((s: typeof State) => (s.order?.order === 'LOADING' ? undefined : s.order?.order))

  const label = useMemo(() => {
    if (!scope) return fallbackId ? `Workspace: ${fallbackId}` : 'Workspace'
    if (scope.kind === 'project') {
      const name = (project?.id === scope.id && project.name) || scope.id
      return `Project: ${name}`
    } else {
      const name = (order?.id === scope.id && order.name) || scope.id
      return `Order: ${name}`
    }
  }, [scope, project, order, fallbackId])

  return <div className="text-sm opacity-70 truncate">{label}</div>
}
